import React from 'react'
import Layout from '../component/Layout/Layout'
import Carousel from "react-bootstrap/Carousel";

export default function ClientDiariesSingle() {
  return (
    <Layout title="Client Diaries : Chaashni by Maansi & Ketan" description="Chaashni Couture: Client Diaries" > 
        <div className="site-content-wrap static-page carousel-box">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="sustom-heading-h1">Shweta <span>Khurana</span></h1>
                        <div className="content-box">
                            <Carousel variant="dark" interval={3000} pause={false} touch={true}>
                                <Carousel.Item><div><img src='/images/catimg/Cocktail.jpg' alt='' /></div></Carousel.Item>
                                <Carousel.Item><div><img src='/images/catimg/Festive-Wear.jpg' alt='' /></div></Carousel.Item>
                                <Carousel.Item><div><img src='/images/catimg/Gowns.jpg' alt='' /></div></Carousel.Item>
                                <Carousel.Item><div><img src='/images/catimg/Indo-Westerns.jpg' alt='' /></div></Carousel.Item>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="site-content-wrap static-page carousel-box">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="sustom-heading-h1">Damneet <span>Kaur</span></h1>
                        <div className="content-box">
                        <Carousel variant="dark" interval={3000} pause={false} touch={true}>
                            <Carousel.Item><div><img src='/images/catimg/Cocktail.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Festive-Wear.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Gowns.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Indo-Westerns.jpg' alt='' /></div></Carousel.Item>
                        </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="site-content-wrap static-page carousel-box">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="sustom-heading-h1">Shweta <span>Khurana</span></h1>
                        <div className="content-box">
                        <Carousel variant="dark" interval={3000} pause={false} touch={true}>
                            <Carousel.Item><div><img src='/images/catimg/Cocktail.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Festive-Wear.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Gowns.jpg' alt='' /></div></Carousel.Item>
                            <Carousel.Item><div><img src='/images/catimg/Indo-Westerns.jpg' alt='' /></div></Carousel.Item>
                        </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}